import { compareFromAndToMonth } from '../../../constant/constantData'
import { IncomingEmpDepartment } from '../../../types/Checklist/ChecklistTypes'
import { MyReviewFormStatus } from '../../../types/Performance/MyReview/myReviewTypes'
import {
  IncomingReviewListCycle,
  IncomingReviewListDesignation,
  OutgoingGetReviewListProps,
} from '../../../types/Performance/ReviewList/reviewListTypes'
import { deviceLocale } from '../../../utils/dateFormatUtils'
import {
  getValueOfReviewStatusMapping,
  reviewStatusMappings,
} from '../MyReviews/MyReviewHelpers'

export const initialReviewListCycle: IncomingReviewListCycle = {
  id: 0,
  name: '',
  description: '',
  toDate: '',
  fromDate: '',
  active: false,
  appraisalType: '',
  appraisalDuration: '',
  level: 0,
  cycleStartedFlag: false,
  appraisalStartDate: '',
  appraisalEndDate: '',
  servicePeriod: 0,
}

export const initialEmpDepartment: IncomingEmpDepartment = {
  departmentId: -1,
  departmentName: '',
  allocationSupportFlag: false,
  supportManagementFlag: false,
}

export const initialDesignation: IncomingReviewListDesignation = {
  id: -1,
  name: '',
  code: null,
  departmentName: initialEmpDepartment.departmentName,
  departmentId: initialEmpDepartment.departmentId,
}

export const initialAppraisalFormStatus = ''
export const customCycleId = -1
export const initialCycleId = ''

export const outgoingInitialGetReviewListProperties: OutgoingGetReviewListProps =
  {
    cycleId: '',
    departmentName: initialEmpDepartment.departmentName,
    designationName: initialDesignation.name,
    employeeID: -1,
    appraisalFormStatus: '',
    searchString: '',
    role: '',
    startIndex: 0,
    endIndex: 20,
    ratings: [],
    empStatus: 'Active',
    fromDate: null,
    toDate: null,
    country: '',
    employmentType: '',
  }

// gets me the department id by filtering with respect to department name
export const getDepartmentIdByDepartmentName = (
  list: IncomingEmpDepartment[],
  deptName: string,
): number => {
  const filteredOne = list.find(
    (deptItem) => deptItem.departmentName === deptName.trim(),
  )
  if (filteredOne === undefined) {
    return initialEmpDepartment.departmentId
  }
  return filteredOne.departmentId
}

// it gets me key, value pair list where key is the data sent to api and value that is displayed on UI
export const getMappedStatusValuesForReviewList = (): [string, string][] => {
  const optionsArray = Object.entries(reviewStatusMappings)
  // removing the last element as it is not required here
  optionsArray.pop()
  return optionsArray
}

export const getNonNullStringValue = (stringVal: string | null): string => {
  return stringVal === null ? '' : stringVal
}

// this takes in date mm/dd/yyyy and gives mm/yyyy only
export const getMonthYearDateOnly = (dateValue: string): string => {
  return dateValue
    ? new Date(dateValue).toLocaleDateString(deviceLocale, {
        year: 'numeric',
        month: 'numeric',
      })
    : ''
}

export const getBadgeColorWithReviewStatusValue = (
  apiValue: string,
): [
  'danger' | 'success' | 'warning' | undefined, // badge color
  string, // value
  string | undefined, //badge className
] => {
  const mappedValue = getValueOfReviewStatusMapping(apiValue)
  if (
    apiValue === MyReviewFormStatus.completed ||
    apiValue === MyReviewFormStatus.closed
  ) {
    return ['success', mappedValue, undefined]
  }
  if (apiValue === MyReviewFormStatus.openForDiscussion) {
    return [undefined, mappedValue, 'discuss-btn']
  }
  if (
    apiValue === MyReviewFormStatus.pending ||
    apiValue === MyReviewFormStatus.submitForEmployee
  ) {
    return ['warning', mappedValue, undefined]
  }
  if (apiValue === MyReviewFormStatus.pendingagreement) {
    return [undefined, mappedValue, 'discuss-btn']
  }
  return ['danger', 'Not-Submitted', undefined]
}

//returns true if field is not entered
export const isDateFieldNotEntered = (value: string | null): boolean => {
  return value === null
}

// returns true if dates are not correctly filled
export const areDateValuesNotCorrectlyFilled = (
  fromDate: string | null,
  toDate: string | null,
): boolean => {
  return (
    isDateFieldNotEntered(fromDate) ||
    isDateFieldNotEntered(toDate) ||
    compareFromAndToMonth(
      getNonNullStringValue(fromDate),
      getNonNullStringValue(toDate),
    )
  )
}

export const reviewRatingsList: string[] = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
]

export const getIndexOfRatingFromList = (
  list: string[],
  value: string,
): null | number => {
  const indexVal = list.findIndex((ratingVal) => ratingVal === value)
  return indexVal === -1 ? null : indexVal
}

export const getFinalFilterOptionsObj = (
  obj: OutgoingGetReviewListProps,
): OutgoingGetReviewListProps => {
  if (obj.cycleId === customCycleId) {
    return obj
  }
  // in order to maintain the internal state not fail api, this is done.
  return {
    ...obj,
    fromDate: null,
    toDate: null,
  }
}

export const getReviewListTestId = (value: string): string => {
  return `reviewList-${value}`
}
